import { render } from "./Employee_Dashboard.vue?vue&type=template&id=c8b1282a&scoped=true"
import script from "./Employee_Dashboard.vue?vue&type=script&lang=js"
export * from "./Employee_Dashboard.vue?vue&type=script&lang=js"

import "./Employee_Dashboard.vue?vue&type=style&index=0&id=c8b1282a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8b1282a"]])

export default __exports__